import { Component } from '@verndale/core';
import Swiper, { Navigation, Pagination } from 'swiper';
import { BREAKPOINTS } from '../utils';

import VideoItem from '../components/video-item';

Swiper.use([Navigation, Pagination]);
class VideoGalleryCarousel extends Component {
  setupDefaults() {
    this.dom = {
      $heading: this.el.querySelector('.video-gallery-carousel__heading'),
      $link: this.el.querySelector('.video-gallery-carousel__link'),
      $swiperContainer: this.el.querySelector('.swiper'),
      $swiperSlides: this.el.querySelectorAll('.swiper-slide'),
      $videos: this.el.querySelectorAll('.video-item'),
      $swiperPagination: this.el.querySelector('.swiper-pagination'),
      $swiperNextButton: this.el.querySelector('.swiper-button-next'),
      $swiperPrevButton: this.el.querySelector('.swiper-button-prev')
    };

    this.isSmallContainer = this.el.closest('.dual-column-container__main');
    this.videos = [...this.dom.$videos].map((video) => new VideoItem(video));
    this.initSwiper();
  }

  initSwiper() {
    let enableSwiper = false;
    const swiperSlides = this.isSmallContainer ? 1 : 2;
    const swiperPaginationType = this.isSmallContainer ? 'fraction' : 'bullets';

    if (this.isSmallContainer) {
      enableSwiper = this.dom.$swiperSlides.length >= 2;
    } else {
      enableSwiper = this.dom.$swiperSlides.length !== 2;
    }

    if (!enableSwiper && this.dom.$link)
      this.dom.$link.classList.add(
        'video-gallery-carousel__link--no-margin-block'
      );

    this.swiper = new Swiper(this.dom.$swiperContainer, {
      a11y: true,
      centeredSlides: true,
      direction: 'horizontal',
      rewind: true,
      slidesPerGroup: 1,
      slidesPerView: 1,
      breakpoints: {
        [BREAKPOINTS.TABLET_LANDSCAPE]: {
          allowTouchMove: false,
          enabled: enableSwiper,
          centeredSlides: false,
          slidesPerGroup: swiperSlides,
          slidesPerView: swiperSlides,
          spaceBetween: 32,
          pagination: {
            type: swiperPaginationType
          }
        }
      },
      pagination: {
        el: this.dom.$swiperPagination,
        type: 'fraction'
      },
      navigation: {
        nextEl: this.dom.$swiperNextButton,
        prevEl: this.dom.$swiperPrevButton
      },
      watchSlidesProgress: true
    });
  }
}

export default VideoGalleryCarousel;
